/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-05-11 14:26:53
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/thirdPartChannel'
  },
  { // 第三方登陆渠道
    path: '/thirdPartChannel',
    name: 'ThirdPartChannel',
    component: () => import(/* webpackChunkName: "thirdPartChannel" */ '../views/thirdPartChannel.vue')
    // meta: { titleKey: '' }
  },
  { // 绑定角色
    path: '/roleBinding',
    name: 'RoleBinding',
    component: () => import(/* webpackChunkName: "infoBinding" */ '../views/infoBinding')
    // meta: { titleKey: 'select_server_role' }
  },
  { // 选择区服绑定
    path: '/infoBinding',
    name: 'InfoBinding',
    component: () => import(/* webpackChunkName: "infoBinding" */ '../views/infoBinding/bindRole')
    // meta: { titleKey: 'select_server_role' }
  },
  { // 登陆失败
    path: '/loginFail',
    name: 'loginFail',
    component: () => import(/* webpackChunkName: "infoBinding" */ '../views/infoBinding/loginFail')
  },
  { // 快速购买
    path: '/buying',
    name: 'buying',
    component: () => import(/* webpackChunkName: "infoBinding" */ '../views/buying')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  if (to.matched.length === 0) {
    next({ path: '/thirdPartChannel' })
  } else {
    next()
  }
})
export default router
